import AccessControl from '../../../SharedComponents/AccessControl';
import { NO_ACCESS_TYPES, PERMISSIONS } from '../../../../utils/constants';

function ManageReportMenu(props) {
    const {
        detailOption,
        handleDetailOptionClick,
        loading
    } = props;

    return (
        <div className={"flex flex-row xl:flex-col gap-3 col-span-2 z-10 w-max xl:w-auto"}>
            <div className={
                "p-3 text-sm rounded-md  flex items-center justify-between font-medium w-max xl:w-auto  " +
                "shadow-sm hover:text-secondary-600 transition transition-all cursor-pointer " +
                (detailOption === "Version History" ? "text-secondary-600 bg-secondary-50 " : "text-blue-gray-600 bg-white ") +
                (loading && "animate-pulse pointer-events-none")
            }
                onClick={() => handleDetailOptionClick("Version History")}
            >
                <span>Version History</span>
            </div>
            <AccessControl requiredPermission={PERMISSIONS.EDIT_DOCUMENT_TAGS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                <div className={
                    "p-3 text-sm rounded-md  flex items-center justify-between font-medium w-max xl:w-auto  " +
                    "shadow-sm hover:text-secondary-600 transition transition-all cursor-pointer " +
                    (detailOption === "Tags" ? "text-secondary-600 bg-secondary-50 " : "text-blue-gray-600 bg-white ") +
                    (loading && "animate-pulse pointer-events-none")
                }
                    onClick={() => handleDetailOptionClick("Tags")}
                >
                    <span>Tags</span>
                </div>
            </AccessControl>
        </div>

    );
}

export default ManageReportMenu;